import React from 'react';
import type { InsightConfigureRouteRedirect as ServicedeskCmdbConfigureType } from '@atlassian/jira-spa-apps-servicedesk-cmdb-configure/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbConfigure = lazyForPaint<typeof ServicedeskCmdbConfigureType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-configure", jiraSpaEntry: "async-servicedesk-cmdb-configure" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-configure'
		),
);

const InsightConfigure = () => (
	<LazyPage
		Page={LazyServicedeskCmdbConfigure}
		pageId="spa-apps/servicedesk/insight/cmdb-configure"
		shouldShowSpinner
	/>
);

export default InsightConfigure;
